import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import dayjs from "dayjs";
import Link from "next/link";
import { mediaUrl } from "@/lib/config/app";
import { getShopConfig } from "@/server/shop/get-shop-config";
import PureHtml from "@/components/custom/PureHtml";
export default function BlogSliderCard(t0) {
  const $ = _c(22);
  const {
    blog
  } = t0;
  const shop = getShopConfig();
  let contentColor = "text-white";
  if (shop.id === "theno1plug") {
    contentColor = "text-primary";
  }
  const blogAltText = blog?.featured_image_alt || blog?.blog_title;
  const t1 = `${mediaUrl}${blog?.blog_image || "noimage.png"}`;
  const t2 = `${blogAltText} Article`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      objectPosition: "top"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t1 || $[2] !== t2) {
    t4 = <div className="relative w-full h-auto min-h-53.5 max-h-53.5 overflow-hidden"><Image src={t1} className="object-cover" quality={60} fill={true} sizes="(max-width: 768px) 100vw, 33vw" alt={t2} style={t3} /></div>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== blog?.created_at) {
    t5 = dayjs(blog?.created_at).format("DD MMM, YYYY");
    $[4] = blog?.created_at;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="text-sm font-semibold opacity-70">{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = blog?.blog_title;
  let t8;
  if ($[8] !== t7) {
    t8 = <h3 className="text-lg line-clamp-1">{t7}</h3>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = blog?.blog_excerpt;
  let t10;
  if ($[10] !== t9) {
    t10 = <PureHtml html={t9} />;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = "/blogs/" + blog?.blog_slug;
  let t12;
  if ($[12] !== t11) {
    t12 = <Link href={t11} className={`bg-secondary ${contentColor} rounded py-2 px-2 w-full font-heading inline-block text-center text-base lg:text-xl mt-2`}>Read Blog</Link>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t12 || $[16] !== t6 || $[17] !== t8) {
    t13 = <div className="p-2">{t6}{t8}{t10}{t12}</div>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t6;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t4) {
    t14 = <div className="h-full shadow bg-white rounded justify-between flex flex-col overflow-hidden hover:-translate-y-1 transition-all duration-300">{t4}{t13}</div>;
    $[19] = t13;
    $[20] = t4;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
}